import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { FaCheckCircle, FaChessKnight, FaGem, FaAward, FaHashtag, FaCheckDouble, FaCalendarAlt } from "react-icons/fa";
import { formatSumma } from "./utils/format";
import "./Verify.css";
import { getRanks, defaultRanks } from "./services/rankService";

function Verify() {
    const [titles, setTitles] = useState(defaultRanks);

    useEffect(() => {
        getRanks().then(setTitles);
    }, []);
    const { fio, stars, solved, coins } = useParams();

    // Decoding params
    const decodedFio = decodeURIComponent(fio);
    const starsCount = parseInt(stars);
    const solvedCount = parseInt(solved) || 0;
    const totalCoins = parseInt(coins) || 0;

    // Calculate Title
    const titleIndex = Math.min(starsCount, titles.length - 1);
    const title = titles[titleIndex >= 0 ? titleIndex : 0];

    return (
        <div className="verify-container">
            <div className="verify-card">
                <div className="verify-icon">
                    <FaCheckCircle />
                </div>
                <h1>TASDIQLANDI</h1>

                <div className="verify-name-large">
                    {decodedFio}
                </div>

                <div className="verify-details">
                    <div className="verify-row compact">
                        <span className="verify-label">Bo'lim:</span>
                        <span className="verify-value section-title">
                            <FaAward className="verify-row-icon" /> Algoritm
                        </span>
                    </div>
                    <div className="verify-row">
                        <span className="verify-label">Daraja:</span>
                        <span className="verify-value rank">
                            <FaChessKnight className="verify-row-icon" /> {title}
                        </span>
                    </div>
                    <div className="verify-row">
                        <span className="verify-label">Masala soni:</span>
                        <span className="verify-value">
                            <FaCheckDouble className="verify-row-icon" /> {solvedCount}
                        </span>
                    </div>
                    <div className="verify-row">
                        <span className="verify-label">Tanga:</span>
                        <span className="verify-value coins">
                            <FaGem className="verify-row-icon" /> {formatSumma(totalCoins)}
                        </span>
                    </div>
                    <div className="verify-row">
                        <span className="verify-label">Status:</span>
                        <span className="verify-value status">Faol</span>
                    </div>
                </div>

                <p className="verify-footer">
                    Ushbu sertifikat <b>Suvoriy.com</b> platformasida haqiqiy deb topildi.
                </p>

                <Link to="/" className="verify-home-btn">
                    Suvoriy.com ga o'tish
                </Link>
            </div>
        </div>
    );
}

export default Verify;
